export const DRAWER_WIDTH = 312

export const MOBILE_BOTTOM_NAV_HEIGHT = 65
